<cmp-component-card
  class="news-modal"
  padding="0px"
  modalClass="no-padding"
  [isModal]="true"
  [noDivider]="true"
  [maxWidth]="800"
  [link]="null"
  [closeModal]="closeModal">
  <img
    class="w-full"
    height="720"
    width="1280"
    ngSrc="assets/images/launchpad-banner.jpeg"
    priority
    alt="launchpad news" />

  <div class="py-[30px] pb-[50px] w-max mx-auto news-modal__body">
    <h1 class="text-center text-gradient text-gradient--yellow max-mobile-medium:text-[32px]">
      Introducing SmartDeFi™ LaunchPad
    </h1>
    <div class="modal__descripiton text-grey-lighter flex flex-col mt-[10px] secondary-text">
      <div class="mb-[50px] text-center">Benefits of launching your token with our SmartDeFi LaunchPad:</div>

      @for (item of items(); track item) {
        <div class="flex items-center secondary-text text-left mt-[15px]">
          <i class="fal fa-plus-circle text-success mr-[10px] text-3xl"></i>{{ item }}
        </div>
      }

      <div class="mt-[50px] flex items-center justify-between secondary-text max-mobile-msmall:mt-[20px]">
        <cmp-button
          class="mx-0"
          [walletCheck]="false"
          color="gradient-yellow"
          buttonClass="w-fit h-[50px] secondary-text mx-0"
          (click)="openDeployer()">
          <i class="icon-deployer text-4xl font-bold mr-[10px]"></i>
          Launch your token</cmp-button
        >
        <a href="https://docs.feg.io/smartdefi-tm-platform/token-launchpad" target="_blank">
          <cmp-button
            class="mx-0 mr-[50px]"
            [walletCheck]="false"
            type="transparent"
            color="gradient-yellow"
            buttonClass="w-fit h-[50px] secondary-text mx-0">
            Learn more</cmp-button
          >
        </a>
      </div>
    </div>
  </div>
</cmp-component-card>
